import { useCallback, useState, type FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AppBar, Box, IconButton, Toolbar, Button } from '@material-ui/core';
import { experimentalStyled, makeStyles } from '@material-ui/core/styles';
import type { AppBarProps } from '@material-ui/core';
import MenuIcon from '../../icons/Menu';
import AccountPopover from './AccountPopover';
// import ContentSearch from './ContentSearch';
import LanguagePopover from './LanguagePopover';
import Logo from '../Logo';
import NotificationsPopover from './NotificationsPopover';
// import NotificationsPopover from './NotificationsPopover';
import AddIcon from '@material-ui/icons/Add';
import CreateCase from '../cases/CreateCase';

interface DashboardNavbarProps extends AppBarProps {
  onSidebarMobileOpen?: () => void;
}
const useStyles = makeStyles({
  alignVertical: {
    display: 'flex',
    alignItems: 'center',
  },
});

const DashboardNavbarRoot = experimentalStyled(AppBar)(({ theme }) => ({
  ...(theme.palette.mode === 'light' && {
    backgroundColor: theme.palette.primary.main,
    boxShadow: 'none',
    color: theme.palette.primary.contrastText,
  }),
  ...(theme.palette.mode === 'dark' && {
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
  }),
  zIndex: theme.zIndex.drawer + 100,
}));

const DashboardNavbar: FC<DashboardNavbarProps> = (props) => {
  const { onSidebarMobileOpen, ...other } = props;
  const classes = useStyles();
  const [drawer, setDrawer] = useState<boolean>(false);

  const addCases = useCallback(
    async (open: boolean, event: any) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }
      setDrawer(open);
    },
    [drawer]
  );

  const handleCloseDrawer = () => {
    setDrawer(!drawer);
  };

  return (
    <DashboardNavbarRoot {...other}>
      <Toolbar sx={{ minHeight: 64 }}>
        <IconButton
          color="inherit"
          onClick={onSidebarMobileOpen}
          sx={{
            display: {
              lg: 'none',
            },
          }}>
          <MenuIcon fontSize="small" />
        </IconButton>
        <RouterLink to="/" className={classes.alignVertical}>
          <Logo height={40} width={40} />
        </RouterLink>
        <Box
          sx={{
            flexGrow: 1,
            ml: 2,
          }}
        />
        <Button
          onClick={(e) => addCases(true, e)}
          // variant="outlined"
          color="inherit"
          startIcon={<AddIcon />}
          sx={{
            mr: 2,
            backgroundColor: '#231F20',
            outline: '1px solid white',
            color: 'white',
          }}>
          Create Case
        </Button>
        <LanguagePopover />
        <Box sx={{ ml: 1 }}>{/* <ContentSearch /> */}</Box>
        <Box sx={{ ml: 1 }}>
          <NotificationsPopover />
        </Box>
        <Box sx={{ ml: 2 }}>
          <AccountPopover />
        </Box>
      </Toolbar>
      {drawer && (
        <CreateCase
          isOpen={drawer}
          addCases={addCases}
          closeDrawer={handleCloseDrawer}
          nested={false}
        />
      )}
    </DashboardNavbarRoot>
  );
};

DashboardNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func,
};

export default DashboardNavbar;
